import { createContext } from 'react';

const BussolaContext = createContext();

export default BussolaContext;
